import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getStudent,
  studentStatus,
} from "../../../features/slices/studentManagementReducer";
import moment from "moment";
import { Link, useLocation } from "react-router-dom";
import CommonPagination from "../../CommonPagination";
import ExportToExcel from "../../ExportToExcel";
import { getStudentPodcast } from "../../../features/slices/studentManagement/studentpodcast";
import TableSkeleton from "../../TableSkeleton";

const initialState = {
  currentPage: 1,
  searchQuery: "",
  fromDate: "",
  toDate: "",
  timeframe: "",
  status: "",
};
const PodcastDetails = () => {
  const [iState, setUpdateState] = useState(initialState);
  const { currentPage, searchQuery, fromDate, toDate, timeframe, status } =
    iState;
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { podcast, loading } = useSelector((state) => {
    return state?.studentpodcast;
  });
  const [page, setPage] = useState(1);
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const totalCount = podcast?.result?.[0]?.totalCount?.[0]?.count || 0;
  const itemsPerPage = 10;

  useEffect(() => {
    dispatch(getStudentPodcast({ userId: state?._id, page }));
  }, [page, dispatch]);

  const handleStatus = (e, id) => {
    const value = e.target.checked ? "ACTIVE" : "INACTIVE";
    const data = { id: id, status: value };
    dispatch(studentStatus(data)).then((data) => {
      if (data?.payload?.code === 200) {
        dispatch(getStudentPodcast()).then((data) => {
          if (data?.payload?.code === 200) {
            setUpdateState((prev) => ({
              ...prev,
              status: "",
            }));
          }
        });
      }
    });
  };
  const handleTimeFrame = (e) => {
    const queryParams = { timeframe: e.target.value, userId: state?._id };
    setUpdateState((prev) => ({
      ...prev,
      timeframe: e.target.value,
    }));
    dispatch(getStudentPodcast(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
      }
    });
  };

  const handleReset = () => {
    setUpdateState(initialState);
    dispatch(getStudentPodcast({ userId: state?._id }));
  };
  const handleSearch = (e) => {
    const { name, value } = e.target;
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmit = () => {
    const queryParams = {
      page: 1,
      search: searchQuery?.trim(),
      status: status,
      userId: state?._id,
    };
    if (fromDate && toDate) {
      queryParams.startDate = fromDate;
      queryParams.endDate = toDate;
    } else if (timeframe) {
      queryParams.timeframe = timeframe;
    }
    dispatch(getStudentPodcast(queryParams)).then((data) => {
      if (data?.payload?.code === 200) {
        setUpdateState((prev) => ({
          ...prev,
          searchQuery: "",
          fromDate: "",
          toDate: "",
          timeframe: "",
        }));
      }
    });
  };
  useEffect(() => {
    if (searchQuery?.trim() !== "") {
      const delayDebounceFunc = setTimeout(() => {
        dispatch(
          getStudentPodcast({ search: searchQuery?.trim(), userId: state?._id })
        ).then((res) => {
          if (res?.payload?.code == 200) {
            // setUpdateState((prev) => ({
            //   ...prev,
            //   searchQuery: "",
            // }));
          }
        });
      }, 1000);
      return () => clearTimeout(delayDebounceFunc);
    }
  }, [searchQuery, dispatch]);
  return (
    <div className="tab-pane fade active show">
      <div className="FilterArea">
        <div className="FilterLeft">
          <div className="form-group">
            <label>From Date</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              disabled={timeframe}
              name="fromDate"
              onChange={(e) => handleSearch(e)}
            />
          </div>
          <div className="form-group">
            <label>To Date</label>
            <input
              type="date"
              className="form-control"
              name="toDate"
              value={toDate}
              disabled={timeframe}
              onChange={(e) => handleSearch(e)}
            />
          </div>
          <div className="form-group">
            <label>&nbsp;</label>
            <button className="Button" onClick={handleSubmit}>
              Apply
            </button>
          </div>
          <div className="form-group">
            <label>Timeframe</label>
            <select
              className="form-control"
              name="timeframe"
              value={timeframe}
              disabled={fromDate || toDate}
              onChange={(e) => handleTimeFrame(e)}
            >
              <option value="" hidden>
                Select
              </option>
              <option value="Today">Today</option>
              <option value="Week">This Week</option>
              <option value="Month">This Month</option>
            </select>
          </div>
        </div>
      </div>
      <div className="NewFilter">
        <div
          className="SearchBox mr-2"
          style={{
            width: "60%",
          }}
        >
          <input
            type="search"
            className="SearchInput "
            placeholder="Search here by ID, Name, or Others"
            name="searchQuery"
            value={searchQuery}
            onChange={(e) => handleSearch(e)}
          />
          <span>
            <i
              className="fa fa-search"
              style={{
                top: "54% !important",
              }}
            />
          </span>
        </div>

        <div className="Actions">
          <button className="Button Cancel" onClick={handleReset}>
            <i className="fa fa-refresh" />
          </button>
          <ExportToExcel
            data={podcast?.result?.[0]?.paginationData}
            fileName="podcast"
          />
        </div>
      </div>
      <div className="TableList">
        <table className="table-hover">
          <thead>
            <tr>
              <th>Sr. No</th>
              <th>Podcast Id</th>
              <th>Podcast Name</th>
              <th>Category &amp; Topic</th>
              <th>Language</th>
              <th>Action</th>
              <th>Ratings</th>
            </tr>
          </thead>
          <tbody>
            {!loading ? (
              podcast?.result?.[0]?.paginationData.length > 0 ? (
                podcast?.result?.[0]?.paginationData.map((res, i) => {
                  return (
                    <tr key={res?._id}>
                      <td>{i + 1 + (page - 1) * 10}</td>
                      <td>{res?.podcastData?.podcast_number}</td>
                      <td>{res?.podcastData?.podcastName}</td>
                      <td>
                        {res?.categoryData?.[0]?.categoryName} &amp;{" "}
                        {res?.topicData?.[0]?.topicName}
                      </td>
                      <td>English</td>
                      <td>
                        <div className="Actions justify-content-start">
                          <Link
                            to={"/podcast/EpisodeList?type=student"}
                            className="Eyes ml-0"
                            state={{ ...res, type: "studentManagemnt" }}
                          >
                            <i className="fa-regular fa-eye" />
                          </Link>
                        </div>
                      </td>

                      <td>
                        <Link
                          to={"/podcast/rating?type=student"}
                          className="LinkDirect"
                          state={res}
                        >
                          {Math.round(res?.averageRating) || 0} (
                          {res?.ratingCount})
                        </Link>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={10}>No Podcast Data</td>
                </tr>
              )
            ) : (
              <TableSkeleton />
            )}
          </tbody>
        </table>
      </div>
      <div className="Pagination">
        {podcast?.result?.[0]?.totalCount?.[0]?.count > 0 && (
          <>
            <p>
              Showing {(page - 1) * 10 + 1} to{" "}
              {podcast?.result?.[0]?.paginationData?.length + (page - 1) * 10}{" "}
              of {podcast?.result?.[0]?.totalCount?.[0]?.count} results
            </p>
            <div className="PaginationRight">
              {podcast?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                <CommonPagination
                  activePage={page}
                  itemsCountPerPage={10}
                  totalItemsCount={
                    podcast?.result?.[0]?.totalCount?.[0]?.count || 0
                  }
                  pageRangeDisplayed={4}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PodcastDetails;
